import apiClient from '@/plugins/axios';

export default {
	getQuestions(searchParam) {
		var query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.questionGroupId
			? `&QuestionGroupId=${searchParam.questionGroupId}`
			: '';
		query += searchParam.description
			? `&Description=${searchParam.description}`
			: '';
		query += searchParam.positive ? `&Positive=${searchParam.positive}` : '';
		query += searchParam.negative ? `&Negative=${searchParam.negative}` : '';
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';

		return apiClient.get(`v1/Question${query}`);
	},

	getQuestion(questionId) {
		return apiClient.get(`v1/Question/${questionId}`);
	},

	createQuestion(question) {
		return apiClient.post('v1/Question', question);
	},

	updateQuestion(question) {
		var questionId = question.id;

		return apiClient.put(`v1/Question/${questionId}`, question);
	},

	deleteQuestion(questionId) {
		return apiClient.delete(`v1/Question/${questionId}`);
	}
};
